import { render, staticRenderFns } from "./Goodslist.vue?vue&type=template&id=e0045466&scoped=true"
import script from "./Goodslist.vue?vue&type=script&lang=js"
export * from "./Goodslist.vue?vue&type=script&lang=js"
import style0 from "./Goodslist.vue?vue&type=style&index=0&id=e0045466&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0045466",
  null
  
)

export default component.exports